import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa'; // Added FaClock
import './contact.css'; 

const ContactSection = () => {
    
    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for your message! We will get back to you shortly.');
        // Add actual form submission logic here
    };

    return (
        <section className="contact-section">
            <div className="container contact-container">
                
                <h2 className="contact-heading">
                    Get  <span className="highlight-green"> in Touch</span>
                </h2>
                <p className="contact-subtitle">
                    Whether you have questions about our loans or need support, our team is ready to help.
                </p>

                <div className="contact-grid">
                    
                    {/* --- 1. Contact Form --- */}
                    <div className="contact-form-wrapper">
                        <h3 className="form-title">Send Us a Message</h3>
                        <form onSubmit={handleSubmit} className="contact-form">
                            
                            <input type="text" placeholder="Your Name" required className="form-input" />
                            <input type="email" placeholder="Your Email" required className="form-input" />
                            <input type="tel" placeholder="Your Phone Number" className="form-input" />
                            
                            <textarea placeholder="Your Message or Query" rows="4" required className="form-textarea"></textarea>
                            
                            <button type="submit" className="submit-button">
                                Send Inquiry
                            </button>
                        </form>
                    </div>

                    {/* --- 2. Map & Details Wrapper (Stacked) --- */}
                    <div className="map-details-wrapper">
                        
                        {/* Live Map Embed */}
                        <iframe 
                            title="Our Location"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.761474122257!2d77.31459607528696!3d28.57692447569521!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce45b22a79785%3A0xac760eff02b41b9a!2sWorld%20Trade%20Tower!5e0!3m2!1sen!2sin!4v1759321448244!5m2!1sen!2sin"
                            width="100%"
                            height="100%" 
                            frameBorder="0"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            aria-hidden="false"
                            tabIndex="0"
                            className="map-iframe"
                        ></iframe>

                        {/* Contact Details */}
                        <div className="contact-details">
                            <h3 className="details-title highlight-magenta">Contact Details</h3>
                            
                            <div className="info-item">
                                <FaMapMarkerAlt className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Corporate Address:</p>
                                    <p className="info-value">101, FinTech Hub, Cyber City, Gurgaon - 122002</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <FaPhone className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Call Us:</p>
                                    <p className="info-value">+91-98765 43210</p>
                                </div>
                            </div>
                            
                            {/* 🌟 NEW: Office Hours Item */}
                            <div className="info-item">
                                <FaClock className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Office Hours:</p>
                                    <p className="info-value">10:00 AM - 7:00 PM (Mon-Fri)</p>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <FaEnvelope className="info-icon accent-magenta" />
                                <div>
                                    <p className="info-label">Email Support:</p>
                                    <p className="info-value">support@yourfinance.com</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ContactSection;